import {FormControl, IconButton, InputAdornment, InputLabel, OutlinedInput} from "@material-ui/core";
import {LoginState} from "../enums/AuthState";
import AppColors from "../colors/AppColors";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import React, {useState} from "react";
import {RootStateOrAny, useDispatch, useSelector} from "react-redux";
import {Constants} from "../constants/Constants";
import {useWelcomeStyle} from "../styles/WelcomeStyle";

export default function LoginPasswordView() {

    const classes = useWelcomeStyle();
    const [showPassword, setShowPassword] = useState(false);
    const password = useSelector((state: RootStateOrAny) => state.appReducer[Constants.AUTH_PASSWORD]);
    const loginState: LoginState = useSelector((state: RootStateOrAny) => state.appReducer[Constants.LOGIN_STATE]);

    const dispatch = useDispatch();

    const handlePasswordChange = (newValue: string | null) => {
        dispatch({
            type: Constants.LOGIN_CREDENTIALS_CHANGED,
            payload: {
                [Constants.AUTH_PASSWORD]: newValue
            }
        });
    }

    const handleKeyEvent = (event: KeyboardEvent) => {
        if (event.keyCode === 13) {
            dispatch({type: Constants.START_LOGIN})
        }
    }

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    }

    const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    }

    return <FormControl
        size="small"
        margin="dense"
        fullWidth
        disabled={loginState === LoginState.STARTED}
        classes={{root: classes.miniAuthFields}}
        variant="outlined">
        <InputLabel htmlFor="outlined-adornment-password">Password</InputLabel>
        <OutlinedInput
            autoComplete="current-password"
            id="outlined-adornment-password"
            name="password"
            type={showPassword ? 'text' : 'password'}
            value={password}
            required
            className={classes.outlinedInput}
            onChange={(event) => {
                handlePasswordChange(event.target.value)
            }}
            onKeyDown={(event) => {
                handleKeyEvent(event as unknown as KeyboardEvent)
            }}
            endAdornment={
                <InputAdornment position="end">
                    <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                        tabIndex="-1"
                        style={{
                            color: AppColors.GREY_TEXT
                        }}
                        disableFocusRipple
                    >{showPassword ? <Visibility fontSize={"small"}/> : <VisibilityOff fontSize={"small"}/>}
                    </IconButton>
                </InputAdornment>
            }
            labelWidth={70}
        />
    </FormControl>
}